import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import { validateRequiredSelect } from '../validate';
import { officesGroupsAge } from '../../../../../constants/group_constant';

const renderAgeGroupField = ({ input, meta: { touched, error }, i18n, ...custom }) => {
    const showError = touched && error;

    return (
        <div
            style={{
                borderBottom: showError ? '2px solid red' : '2px solid transparent',
                paddingBottom: 4,
            }}
        >
            <NativeSelect {...input} {...custom}>
                <option value="">{i18n.t('groups.choose_age')}</option>
                {Object.keys(officesGroupsAge).map(key => (
                    <option key={key} value={key}>
                        {i18n.t(officesGroupsAge[key])}
                    </option>
                ))}
            </NativeSelect>
        </div>
    );
};

export default ({ label, code }) => {
    const { i18n } = useTranslation();

    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                    {i18n.t(label)}
                </Typography>
                <Field
                    name={code}
                    i18n={i18n}
                    component={renderAgeGroupField}
                    type="text"
                    validate={validateRequiredSelect}
                />
            </CardContent>
        </Card>
    );
};
